class UFilteredList extends Uneet {
  constructor (domElement) {
    super(domElement)
    this.curentPage = 0
    this.isShowingLoader = true
    this.isShowingFilters = false
    this.isShowingSelectedFilters = false
    this.isShowingLoadMore = false
    this.sortControl = null // initialized later
    this.filters = null // initialized later
    this.selectedFilters = null // initialized later
    this.eventTypeSelector = null // initialized later
    this.listItems = []
    this.__init()
    this.__firstFetch()
  }

  __init () {
    // -- DOM STUFF:
    // get item template
    this.__template = this._e.querySelectorAll('.u_filtered-list-item.isTemplate')[0]
    // bind filter-by btn
    this._e.querySelectorAll('button.filter-by-btn')[0].onClick((ev) => {
      this.toggleFilterDisplay()
    })
    // bind no results clear filters button
    this._e.querySelectorAll('div.no-results button.clear-filters-btn')[0].onClick((ev) => {
      this.filters.clearAll()
    })
    // bind the load more button
    this._e.querySelectorAll('button.load-more')[0].onClick((ev) => {
      this.__loadMoreFetch()
    })
    // -- SUB COMPONENT STUFF:
    // init the sort btn
    const sortBtnElem = this._e.querySelectorAll('.u_filtered-list-sort-selector')[0]
    this.sortControl = new UFilteredListSortSelector(sortBtnElem, (isAscending) => {
      this.onDateSortUpdate(isAscending)
    })
    // init the type selector
    const typeSelector = this._e.querySelectorAll('.u_filtered-list-event-type-selector')[0]
    this.eventTypeSelector = new UFilteredListEventTypeSelector(typeSelector, (initialIsUpcoming, newIsUpcoming) => {
      this.filters.clearAll()
      this.onTypeChange(initialIsUpcoming, newIsUpcoming)
    })
    // init the filters
    this.filters = new UFilteredListFilters(
      this._e.querySelectorAll('.u_filtered-list-filters')[0],
      () => {
        this.toggleFilterDisplay()
      },
      (alteredFilter, alteredFilterItem) => {
        this.onFilterUpdate(alteredFilter, alteredFilterItem)
      },
      (dateFilter, prevYear) => {
        this.onDateFilterUpdate(dateFilter, prevYear)
      }
    )
    // init the selected filters
    this.selectedFilters = new UFilteredListSelectedFilters(
      this._e.querySelectorAll('.u_filtered-list-selected-filters')[0],
      () => { // clearAllClickCB
        this.filters.clearAll()
      }
    )
  }

  // *** *** *** *** ***
  // Component button cb functions:
  // *** *** *** *** ***

  toggleFilterDisplay (force = null) {
    if (force === null) {
      this.isShowingFilters = !this.isShowingFilters
    } else {
      this.isShowingFilters = force
    }

    this._e.toggleClass('isShowingFilters', this.isShowingFilters)

    // this is a bit of cheating, prevent body scrolling
    const body = document.querySelectorAll('body')[0]
    if (this._e.hasClass('isShowingFilters')) {
      body.addClass('modal-open')
    } else {
      body.removeClass('modal-open')
    }
  }

  // *** *** *** *** ***
  // Subcomponent changes related functions:
  // *** *** *** *** ***

  onFilterUpdate (alteredFilter, alteredFilterItem) {
    this.__log('filters changed, fetching...')
    const hasActiveFilters = (this.filters.getActiveFilterCount() > 0)
    this.__toggleSelectedFiltersDisplay(hasActiveFilters)
    this.selectedFilters.updateSelectedFilters(this.filters.getAllFiltersForSelectedFilters())
    this.__firstFetch()
  }

  onDateFilterUpdate (dateFilter, prevYear) {
    this.__log('date filter changed, fetching...')
    const hasActiveFilters = (this.filters.getActiveFilterCount() > 0)
    this.__toggleSelectedFiltersDisplay(hasActiveFilters)
    this.selectedFilters.updateSelectedFilters(this.filters.getAllFiltersForSelectedFilters())
    this.__firstFetch()
  }

  onDateSortUpdate (isAscending) {
    this.__log('date sort changed, fetching...')
    this.__firstFetch()
  }

  onTypeChange (oldIsUpcoming, newIsUpcoming) {
    this.__log('event type changed, fetching...')
    this.filters.toggleDateFilter(newIsUpcoming)
    this.sortControl.toggleSort(newIsUpcoming)
    this.__firstFetch()
  }

  // *** *** *** *** ***
  // data fetch related functions:
  // *** *** *** *** ***

  __firstFetch () {
    this.__log('Loading First')
    this.currentPage = 1
    this.__clearItems()
    this.__toggleNoResults(false)
    this.__toggleLoader(true)
    this.__fetchItems()
  }

  __loadMoreFetch () {
    this.__log('Loading More')
    this.currentPage = this.currentPage + 1
    this.__toggleLoader(true)
    this.__fetchItems()
  }

  __fetchItems () {
    if (this.__debouncedFetch === undefined) {
      this.__debouncedFetch = this.__debounce(() => {
        const urlAppend = this.__getURLAppend()
        this.__log(urlAppend)
        this.__ajax(
        this.endpoint + '?' + urlAppend,
        (request) => {
          this.__processData(JSON.parse(request.response))
          this.__toggleLoader(false)
        },
        (request) => {
          window.alert('There was an error while getting the results, please refresh and try again. If the problem persists, please contact the adminisitrator.')
          this.__throwUneetError('Error while loading Filtered List Results', request.status + ' ' + request.statusText, request)
        }
      )
      }, 1000)
    }
    this.__debouncedFetch()
  }

  __getURLAppend () {
    // format:
    // past=true&sort=date&sort_type=ASC&start_date=2014-01-01&end_date=2014-02-02&admission=1,2,3,4&event-type=1,2,3,4
    const dateSort = this.sortControl.getSort()
    const activeFilters = this.filters.getActiveFilters()
    const eventType = this.eventTypeSelector.getType()
    const page = this.currentPage
    const isUpcoming = (eventType === 'upcoming')
    let appendURL = ''
    appendURL += 'page=' + page
    appendURL += (isUpcoming) ? '' : '&past=true'
    appendURL += '&sort=date&sort_type=' + dateSort
    appendURL += ((activeFilters) => {
      if (activeFilters === null) {
        return ''
      } else {
        const keys = Object.keys(activeFilters)
        let result = ''
        keys.forEach((key) => {
          result += '&' + key + '=' + activeFilters[key].toString()
        })
        return result
      }
    })(activeFilters)
    appendURL += ((dateFilterVal) => {
      if (isUpcoming) {
        return ''
      } else {
        let ret = ''
        const today = new Date()
        // construct end_date based on today's date
        if ((dateFilterVal === null) || (today.getFullYear() === dateFilterVal)) {
          const yesterday = new Date(today)
          yesterday.setDate(today.getDate() - 1)
          const currentDateStr = yesterday.toISOString().substring(0, 10)
          ret += '&' + 'end_date=' + currentDateStr
        } else {
          ret += '&' + 'end_date=' + dateFilterVal + '-12-31'
        }
        // construct start_date based on dateFilterVal only
        const endYear = (dateFilterVal === null) ? '1980' : dateFilterVal
        ret += '&' + 'start_date=' + endYear + '-01-01'
        return ret
      }
    })(this.filters.getDateFilter())

    return appendURL
  }

  __processData (data) {
    if (data.results.length < 1) {
      this.__toggleNoResults(true)
    } else {
      this.__toggleNoResults(false)
      this.__toggleLoadMore(!data.is_last_page)
      this.__createItems(data)
      this.__updateActiveFilterCounts(this.filters.getActiveFilterCount())
      this.__updateItemCounts(data.total)
    }
  }

  __toggleLoader (force = null) {
    if (force === null) {
      this.isShowingLoader = !this.isShowingLoader
    } else {
      this.isShowingLoader = force
    }

    this._e.toggleClass('isShowingLoader', this.isShowingLoader)
  }

  __toggleSelectedFiltersDisplay (force) {
    if (force === null) {
      this.isShowingSelectedFilters = !this.isShowingSelectedFilters
    } else {
      this.isShowingSelectedFilters = force
    }

    this._e.toggleClass('isShowingSelectedFilters', this.isShowingSelectedFilters)
  }

  __updateActiveFilterCounts (count) {
    const countDOM = this._e.querySelectorAll('button.filter-by-btn span.filter-count')[0]
    countDOM.innerHTML = count
    countDOM.toggleClass('isShown', (count !== 0))
  }

  __updateItemCounts (count) {
    this.selectedFilters.updateCount(count)
    this._e.querySelectorAll('div.result-count')[0].innerHTML = count
  }

  __toggleNoResults (force = null) {
    if (force === null) {
      this.hasNoResults = !this.hasNoResults
    } else {
      this.hasNoResults = force
    }

    this._e.toggleClass('hasNoResults', this.hasNoResults)
  }

  __toggleLoadMore (turnOn = null) {
    if (turnOn === null) {
      this.isShowingLoadMore = !this.isShowingLoadMore
    } else {
      this.isShowingLoadMore = turnOn
    }
    this._e.toggleClass('isShowingLoadMore', this.isShowingLoadMore)
  }

  __clearItems () {
    while (this.listItems.length > 0) {
      this.listItems[this.listItems.length - 1].delete()
      this.listItems.splice(-1, 1)
    }
  }

  __createItems (data) {
    // create all the elements based on data
    for (let i = 0; i < data.results.length; i++) {
      const d = data.results[i]
      const templateClone = this.__template.cloneNode(true)
      const item = new UFilteredListItem(templateClone, d, (this.eventTypeSelector.getType() === 'upcoming'))
      this.listItems.push(item)
      const itemWrapper = document.createElement('div')
      itemWrapper.addClass('listing-item')
      itemWrapper.appendChild(item._e)
      this._e.querySelectorAll('div.listing-items')[0].appendChild(itemWrapper)
    }
  }

  test () {
    this.__log(this)
  }
}

window.addEventListener('load', function () {
  const filteredListDOMElement = document.querySelectorAll('.u_filtered-list')[0]
  if (filteredListDOMElement !== undefined) {
    const filteredList = new UFilteredList(document.querySelectorAll('.u_filtered-list')[0])
    filteredList.test()
  }
})
